const surveyType = (payload) => {
  return {
    type: "typeofsurvey",
    payload,
  };
};

export default surveyType;
